<div
  v-if="shouldRenderConfig"
  v-bind:class="getClassName"
>
  <button type="button" class="btn btn-primary" v-on:click="onClick()">
    {{ $t('Apply preferred selection') }}
  </button>
</div>
